// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItem-cls1__d016b1c4774c6d21f2e5","cls2":"CreateSocialItem-cls2___cb5eef25c5a68d44ce1 CreateSocialItem-cls1__d016b1c4774c6d21f2e5"};